import React from 'react';
import { connect } from 'react-redux';

import PaySection from '../PaySection/PaySection';
import s from './RelatedProduct.module.scss';

const RelatedProduct = props => {
  const { good, t } = props;
  if (!good.locData || !t.language) return null;
  const goodData = good.locData[t.language];
  if (!goodData) return null;
  const goodImage = good.img;

  return (
    <div className={s.main}>
      <div className={s.imageGood}>
        <div className={s.thumbnail}>
          <a href={`/good/${good.seo_url || good.id}`}>
            <img
              src={goodImage.src}
              alt={goodImage.alt}
              title={goodImage.title}
            />
          </a>
        </div>
      </div>
      <div className={s.descriptionRelatedProduct}>
        <div className={s.name}>
          <a href={`/good/${good.seo_url || good.id}`}>
            <h4>{goodData.name}</h4>
          </a>
          <p className={s.descriptionPreview}>{goodData.description_preview}</p>
        </div>
        <div>
          <PaySection id={good.id} />
          {/* <p className={s.note}>
            Внешний вид товара может отличаться от представленного на сайте
          </p> */}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  t: state.translation
});

export default connect(mapStateToProps)(RelatedProduct);
